module.exports = __webpack_public_path__ + "../resources/images/illustration_junk-07bc6ff1330625e5caf96df6d6fdafb9.svg";